import { createContext } from 'react'

export const DepositContext = createContext({})
